<div class="container">
      <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
      <span class="icon"><i class="fas fa-truck-plane"></i></span>{{ 'Menu.Menu.FSCSSCSetting' | translate }}</h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
        <form [formGroup]="searchForm">
          <div class="p-fluid formgrid grid">
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'FSCSSCSetting.Search.Forwarder' | translate }}</label>
              <p-multiSelect formControlName="forwarder" [options]="forwarderOptions" [filter]="true" [(ngModel)]="searchParams.forwarder"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </p-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'FSCSSCSetting.Search.CostType' | translate }}</label>
              <p-multiSelect formControlName="feeType" [options]="feeTypeOptions" [filter]="true" [(ngModel)]="searchParams.feeType"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </p-multiSelect>
            </div>
            <div class="field col-6">
              <label>{{ 'FSCSSCSetting.Search.SerialNum' | translate }}</label>
              <div class="grid">
                <div class="col">
                  <p-inputNumber formControlName="startSeqNo" [(ngModel)]="searchParams.startSeqNo" mode=decimal></p-inputNumber>
                </div> ~
                <div class="col">
                  <p-inputNumber formControlName="endSeqNo" [(ngModel)]="searchParams.endSeqNo" mode=decimal></p-inputNumber>
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'FSCSSCSetting.Search.DepartureCountry' | translate }}</label>
              <p-multiSelect formControlName="fromCountry" [options]="countryOptions" [filter]="true" [(ngModel)]="searchParams.fromCountry"
                 placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </p-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'FSCSSCSetting.Search.DestinationIATA' | translate }}</label>
              <p-multiSelect formControlName="toIataArea" [options]="iataAreaOptions" [filter]="true" [(ngModel)]="searchParams.toIataArea"
                 placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </p-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'FSCSSCSetting.Search.Status' | translate }}</label>
              <p-multiSelect formControlName="status" [options]="statusOptions" [filter]="true" [(ngModel)]="searchParams.status"
                 placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </p-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'FSCSSCSetting.Search.Effective' | translate }}</label>
              <p-dropdown formControlName="isActivated" [options]="isActivatedOptions" [(ngModel)]="searchParams.isActivated"
                [showClear]="true" placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </p-dropdown>
            </div>

            <div class="col-12 md:col-6 lg:col-3 laas-calendar">
              <laas-calendar
                  #effectDate
                  [title]="'FSCSSCSetting.Search.EffectiveDate'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  [monthRange]="12"
                  (onDateChange)="dateOnChange($event,'effectDate')">
              </laas-calendar>
            </div>

          </div>
          <div class="grid">
            <div class="col">
              <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchClickBtn($event)"></button>
              <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetClickBtn($event)" class="p-button-secondary ml-2"></button>
              <laas-permission-button permissionCode="CreateAirwaysExpense" label="{{ 'FSCSSCSetting.Button.New' | translate }}" (onClick)="addClickBtn($event)" [class]="'ml-2'"></laas-permission-button>
              <laas-permission-button permissionCode="CreateAirwaysExpense" label="{{ 'FSCSSCSetting.Button.Import' | translate }}" (onClick)="importClickBtn($event)" [class]="'ml-4'"></laas-permission-button>
              <button pButton pRipple label="{{ 'FSCSSCSetting.Button.Export' | translate }}" [disabled]="!airwaysExpenseRows.length" (click)="exportClickBtn($event)" class="ml-2"></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
      <laas-data-table [tableKey]="preferenceKey" [selectable]="true" [(selectedRows)]="selectedAirwaysExpenseRows" [dataKey]="'seqNo'" [value]="airwaysExpenseRows" [defaultColumns]="columns" [loading]="isLoading">
        <ng-template pTemplate="caption">
            <laas-permission-button permissionCode="BtnAirwaysExpenseApply" label="{{ 'FSCSSCSetting.Button.Apply' | translate }}" [disabled]="!selectedAirwaysExpenseRows.length"
            (onClick)="applyClickBtn($event)" [class]="'ml-2'"></laas-permission-button>
            <laas-permission-button permissionCode="BtnAirwaysExpenseRecall" label="{{ 'FSCSSCSetting.Button.Withdraw' | translate }}" [disabled]="!selectedAirwaysExpenseRows.length"
            (onClick)="withdrawClickBtn($event)" [class]="'p-button-secondary ml-2'"></laas-permission-button>
            <laas-permission-button permissionCode="BtnAirwaysExpenseDelete" label="{{ 'FSCSSCSetting.Button.Delete' | translate }}" [disabled]="!selectedAirwaysExpenseRows.length"
            (onClick)="deleteClickBtn($event)" [class]="'p-button-secondary ml-2'"></laas-permission-button>
            <laas-permission-button permissionCode="BtnAirwaysExpenseApproved" label="{{ 'FSCSSCSetting.Button.Approved' | translate }}" [disabled]="!selectedAirwaysExpenseRows.length"
            (onClick)="approveClickBtn($event)" [class]="'ml-2'"></laas-permission-button>
            <laas-permission-button permissionCode="BtnAirwaysExpenseInvalid" label="{{ 'FSCSSCSetting.Button.Void' | translate }}" [disabled]="!selectedAirwaysExpenseRows.length"
            (onClick)="cancelClickBtn($event)" [class]="'p-button-secondary ml-2'"></laas-permission-button>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'seqNo'">
                <div class="overflow-text">
                  <a href="javascript: void(0);" (click)="seqNoLinkClick($event, rowData)">{{rowData[col.field]}}</a>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'forwarder'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:forwarderOptions | replaceNullWith:'-'}}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'feeType'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:feeTypeOptions | replaceNullWith:'-'}}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'currency'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:currencyOptions | replaceNullWith:'-'}}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'status'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:statusOptions | replaceNullWith:'-'}}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'fromCountry'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:countryOptions | replaceNullWith:'-'}}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'toIataArea'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:iataAreaOptions | replaceNullWith:'-'}}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'isActivated'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:isActivatedOptions | replaceNullWith:'-'}}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'startDt'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'endDt'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith:'-'}}
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
  <ng-container *ngIf="isShowImportAirwaysExpenseModal">
    <laas-airways-expense-setting-import [(visible)]="isShowImportAirwaysExpenseModal"  (importClick)="importAirwaysExpense($event)"></laas-airways-expense-setting-import>
  </ng-container>
</div>

<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
